import React, { useEffect } from 'react';
import { FaStar, FaCheckCircle } from 'react-icons/fa';
import { HiSparkles } from 'react-icons/hi';
import './SpotlightSuccessModal.scss';

interface SpotlightSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string; // "Post Spotlighted!" or "Profile Spotlighted!"
  message: string; // e.g., "Your post is now featured for 24 hours"
  duration?: number; // Auto close after X ms (optional)
}

/**
 * Success modal for spotlight purchases
 * Shows a celebratory message with animations
 */
export const SpotlightSuccessModal: React.FC<SpotlightSuccessModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
  duration = 3000, // Auto close after 3 seconds by default
}) => {
  useEffect(() => {
    if (isOpen && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, duration]);

  if (!isOpen) return null;

  return (
    <div className="spotlight-success-overlay" onClick={onClose}>
      <div className="spotlight-success-modal" onClick={(e) => e.stopPropagation()}>
        {/* Success Icon */}
        <div className="success-icon-container">
          <div className="success-icon-bg">
            <FaCheckCircle className="success-check" />
          </div>
          <div className="sparkles-container">
            <HiSparkles className="sparkle sparkle-1" />
            <HiSparkles className="sparkle sparkle-2" />
            <HiSparkles className="sparkle sparkle-3" />
            <HiSparkles className="sparkle sparkle-4" />
          </div>
        </div>

        {/* Success Message */}
        <div className="success-content">
          <h2 className="success-title">
            <FaStar className="title-star" />
            {title}
          </h2>
          <p className="success-message">{message}</p>
        </div>

        {/* Close Button */}
        <button className="success-close-btn" onClick={onClose}>
          Got it!
        </button>
      </div>
    </div>
  );
};

export default SpotlightSuccessModal;
